import { OfferApplicantStatus } from "./../../types/OfferApplicantStatus.interface";

// Configuration des badges
const greenBadgeStyle: React.CSSProperties = {
  backgroundColor: '#0F2A1D',
  color: '#34D399',
  border: '1px solid #165B3E',
};

const redBadgeStyle: React.CSSProperties = {
  backgroundColor: '#2A0F0F',
  color: '#F87171',
  border: '1px solid #5B1616',
};

const yellowBadgeStyle: React.CSSProperties = {
  backgroundColor: '#2A2A0F',
  color: '#FACC15',
  border: '1px solid #5B5B16',
};

export const inputStatusColorMap: Record<string, React.CSSProperties> = {
  // --- BONS STATUTS (Vert) ---
  [OfferApplicantStatus.HIRED]: greenBadgeStyle,
  [OfferApplicantStatus.SHORTLISTED_BY_HR_QUESTIONNAIRE]: greenBadgeStyle,
  [OfferApplicantStatus.SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE]: greenBadgeStyle,
  [OfferApplicantStatus.SHORTLISTED_BY_IA]: greenBadgeStyle,
  [OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE]: greenBadgeStyle,

  // --- MAUVAIS STATUTS (Rouge) ---
  [OfferApplicantStatus.REJECTED_BY_IA]: redBadgeStyle,
  [OfferApplicantStatus.REJECTED_BY_HR_QUESTIONNAIRE]: redBadgeStyle,
  [OfferApplicantStatus.REJECTED_BY_TECHNICAL_QUESTIONNAIRE]: redBadgeStyle,
  [OfferApplicantStatus.REJECTED_AFTER_FINAL_REVIEW]: redBadgeStyle,
  [OfferApplicantStatus.OFFER_REJECTED_BY_CANDIDATE]: redBadgeStyle,

  // --- AUTRES STATUTS ---
  [OfferApplicantStatus.UNDER_FINAL_REVIEW]: yellowBadgeStyle, // Ou définissez un yellowBadgeStyle si nécessaire
};